var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hr',{class:("bg-" + _vm.v),staticStyle:{"margin":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }